import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, MaskLines, Reveal } from "./Reveal";

const TAGS = ["Loafing sheds", "Run-in shelters", "Barns", "Metal roofing"];

export const Barns = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="barns" ref={ref} data-testid="barns-section" className="bg-[#0D1015] py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <Reveal className="order-2 lg:order-1 lg:col-span-6">
          <div data-testid="barns-photo" className="clip-corner group relative overflow-hidden bg-[#12161F]">
            <div className="grid grid-cols-2 gap-px bg-white/10">
              <motion.img style={{ y, scale: 1.15 }} src="/images/barn-1.jpg" alt="A run-in shelter under construction with a red metal roof" loading="lazy" className="aspect-[1102/1193] w-full object-cover" />
              <motion.img style={{ y, scale: 1.15 }} src="/images/barn-2.jpg" alt="Inside a livestock run-in shelter, framed stall walls" loading="lazy" className="aspect-[1102/1193] w-full object-cover" />
            </div>
            <p className="absolute bottom-5 left-5 bg-black/60 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white">Run-in shelter · Outside & in</p>
          </div>
        </Reveal>
        <div className="order-1 lg:order-2 lg:col-span-6">
          <Eyebrow>Barns & shelters</Eyebrow>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">
            <MaskLines inView lines={["Barns &", <span key="l" className="text-blue-500">livestock shelters.</span>]} />
          </h2>
          <Reveal>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
              From run-in shelters and loafing sheds to full barns, we build sturdy animal housing framed right and finished with metal roofing — ready for horses, cattle and whatever else you keep.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {TAGS.map((t) => (
                <span key={t} className="border border-white/15 px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider text-slate-300">{t}</span>
              ))}
            </div>
            <a href="#contact" data-testid="barns-quote-link" className="btn-primary mt-9">Plan a Barn <span className="text-base leading-none">→</span></a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
